import { LoruleRequestConfig } from '@galaxy/lorule-react-commons';
import { callWebUtils, commonHeaders } from './commonApiUtil';
import { AmTemplateType, NclDevCode, NclDepartment } from './amTemplateApiTypes';

export const getUserTemplates = async (config: LoruleRequestConfig) =>
    callWebUtils<Array<AmTemplateType>>(
        config,
        '/template?filtered=true',
        'GET',
        null,
        commonHeaders,
    );

export const getTemplates = async (config: LoruleRequestConfig, type?: string) =>
    callWebUtils<Array<AmTemplateType>>(
        config,
        `/template${type ? `?type=${encodeURIComponent(type)}` : ''}`,
        'GET',
        null,
        commonHeaders,
    );

export const getNclDepartments = async (config: LoruleRequestConfig) =>
    callWebUtils<Array<NclDepartment>>(
        config,
        '/template/ncldepartment',
        'GET',
        null,
        commonHeaders,
    );

export const getNclDevCodes = async (config: LoruleRequestConfig, searchValue?: string) =>
    callWebUtils<Array<NclDevCode>>(
        config,
        `/template/ncldevcode${searchValue ? `?searchValue=${searchValue}` : ''}`,
        'GET',
        null,
        commonHeaders,
    );
